/* eslint no-console: "off", quotes: "off" */
import { mapState, mapActions, mapMutations } from "vuex";
import ResumeGame from "@/components/home/modals/ResumeGame";
import ZeroBalance from '@/components/home/modals/ZeroBalance';
import ResubscribeGameSms from '@/components/home/modals/ResubscribeGameSms';
import ResubscribeGame from '@/components/home/modals/ResubscribeGame';
import Maintenance from '@/components/home/modals/Maintenance';

const NewGameMixin = {
  data() {
    return {
      currentModal: null,
    };
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapActions('game', [
      'checkIfGameToResumeExists',
    ]),
    ...mapActions('profile', [
      'checkCoreResponses',
    ]),
    playGameForFreeTrial() {
      this.checkCoreResponses().then((response) => {
        if (response === 'CORE_IS_DOWN') {
          this.currentModal = Maintenance;
          this.showModalForMaintenance();
        } else {
          this.$router.push('/searchingOpponent');
        }
      }).catch(error => console.error(error));
    },
    playGame({ closeModalOnRedirect = false } = {}) {
      this.checkCoreResponses().then((response) => {
        if (response === 'CORE_IS_DOWN') {
          this.currentModal = Maintenance;
          this.showModalForMaintenance();
        } else {
          this.checkIfGameToResumeExists().then(() => {
            console.log('this.gameInProgress in Home js:', this.gameInProgress);
            if (this.gameInProgress) {
              console.log('showing resume game pop up in Home js...');
              this.currentModal = ResumeGame;
              this.showHideModal();
            } else if (this.userDetails.availableGames === 0 && !this.userDetails.subscribed) {
              if (this.subAndUnsubViaSMS) {
                if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                  this.storeModalForHomePage(ResubscribeGameSms);
                } else {
                  this.storeModalForHomePage(ResubscribeGame);
                }
              } else {
                this.storeModalForHomePage(ResubscribeGame);
              }
              this.showHideModal();
            } else if (this.userDetails.availableGames === 0 && this.userDetails.subscribed) {
              this.storeModalForHomePage(ZeroBalance);
              this.showHideModal();
            } else {
              if (closeModalOnRedirect) {
                this.storeModalForHomePage(null);
              }

              this.$router.push('/searchingOpponent');
            }
          }).catch(error => console.error(error));
        }
      }).catch(error => console.error(error));
    },
    playGameForPages() {
      this.checkCoreResponses().then((response) => {
        if (response === 'CORE_IS_DOWN') {
          this.currentModal = Maintenance;
          this.showHideModal();
        } else {
          this.checkIfGameToResumeExists().then(() => {
            console.log('this.gameInProgress in Home js:', this.gameInProgress);
            if (this.gameInProgress) {
              console.log('showing resume game pop up in Home js...');
              this.currentModal = ResumeGame;
              this.showHideModal();
            } else if (this.userDetails.availableGames === 0) {
              this.currentModal = ZeroBalance;
              this.showHideModal();
            } else {
              this.$router.push('/searchingOpponent');
            }
          }).catch(error => console.error(error));
        }
      }).catch(error => console.error(error));
    },
    showModalForMaintenance() {
      /* eslint-disable */
      // open modal
      this.$nextTick(() => {
        console.log('Open Maintenance modal...');
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // hide modal
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          console.log('Hide Maintenance modal and log out...');
          this.currentModal = null;
          this.storeModalForHomePage(null);
          window.location.reload();
          this.$router.push('/');
        });
      });
      /* eslint-enable */
    },
    showHideModal() {
      this.$nextTick(() => {
        /* eslint-disable */
        // open modal
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // hide modal
        $('.modal-close,.modal-overlay,.overlay,.btn_close').click(() => {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          this.currentModal = null;
          this.storeModalForHomePage(null);
          /* eslint-enable */
        });
      });
    },
  },
  computed: {
    ...mapState('game', [
      'gameInProgress',
    ]),
    ...mapState('common', [
      'userDetails',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
    ]),
  },
};

export default NewGameMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/home.js